// extracted by mini-css-extract-plugin
module.exports = {"container":"okDvNzyDua2w0i2MO00Ha","wide":"udMbLLmD0rLsMxzeE2pw7","content":"_3ThtInVchDiMFMUF98LTIx","grey":"_3QcHWCL1UJPhE4gobVcW61"};